module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        Please Log in!\n      ")]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name",
      "rules": _vm.nameRules,
      "counter": 10,
      "required": ""
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Password",
      "rules": _vm.passwordRules,
      "type": "password",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "success": "",
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n            Log in\n          ")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "error": "",
      "dismissible": "",
      "icon": "warning",
      "value": "true"
    },
    model: {
      value: (_vm.loginProblem),
      callback: function($$v) {
        _vm.loginProblem = $$v
      },
      expression: "loginProblem"
    }
  }, [_vm._v("\n         Your username or password is incorrect!\n       ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61feba32","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 48
// module chunks = 1